/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')


if (document.querySelectorAll('.rellax').length) {
  let rellax = new Rellax('.rellax')
}

let ourTeamSlider = new Swiper('.js-front-team', {
  loop: true,
  pagination: '.swiper-pagination',
  paginationClickable: true,
})

let partnersSlider = new Swiper('.js-partners-slider', {
  paginationHide: true,
  direction: 'vertical',
  slidesPerView: 1,
  centeredSlides: true,
  nextButton: '.front-partners__next',
  prevButton: '.front-partners__prev',
  breakpoints: {
    768: {
      paginationHide: false,
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: '.swiper-pagination',
      paginationBulletRender(swiper, index, className) {
        return `<span class="${className}"></span>`
      },
      paginationClickable: true,
    },
  },
});

// (() => {
//   let modalSubmitRequest = new tingle.modal({
//     closeMethods: [],
//     cssClass: ['modal-submit-request'],
//   })
//   const el = document.querySelector('.js-callRequestSubmit')
//   if (el) {
//     el.addEventListener('click', event => {
//       event.preventDefault()
//       modalSubmitRequest.open()
//       modalSubmitRequest.setContent(document.getElementById('modalSubmitRequest').innerHTML)
//     })
//   }
// })();
//
// (() => {
//   const el = document.querySelector('.js-callGetConsultation')
//   let modalGetConsultation = new tingle.modal({
//     closeMethods: [],
//     cssClass: ['modal-get-consultation'],
//   })
//   if (el) {
//     el.addEventListener('click', event => {
//       event.preventDefault()
//       modalGetConsultation.open()
//       modalGetConsultation.setContent(document.getElementById('modalGetConsultation').innerHTML)
//     })
//   }
// })();

// var inview = new Waypoint.Inview({
//   element: document.querySelector('.front-hero__macbook'),
//   enter(direction) {
//     // console.log('Enter triggered with direction ' + direction)
//   },
//   entered(direction) {
//     const element = this.element
//     const elementContent = this.element.querySelector('.front-hero__macbook-content')
//     const elementImg = this.element.querySelector('.front-hero__macbook-img')
//     const calc = element.getBoundingClientRect().bottom - elementContent.getBoundingClientRect().bottom
//
//     const scrollArea = document.querySelector('.front-hero__macbook-content')
//     // const elementStart = element.getBoundingClientRect().top;
//     let scrollHeight = 0
//     let scrollOffset = 0
//     let scrollPercent = 0
//
//     resize()
//
//     function loop() {
//       scrollOffset = window.pageYOffset || window.scrollTop
//       scrollPercent = scrollOffset / scrollHeight || 0
//       const transformString = `translate3d(0, -${scrollPercent * 1000}px, 0)`
//       elementImg.style.mozTransform = transformString
//       elementImg.style.webkitTransform = transformString
//       elementImg.style.transform = transformString
//
//       requestAnimationFrame(loop)
//     }
//
//     loop()
//
//     function resize () {
//       scrollHeight = window.innerHeight * 4
//       // scrollArea.style.height = (window.innerHeight * 5) + 'px'
//     }
//
//     window.addEventListener('resize', resize)
//
//     // window.onscroll = function () {
//     //   let scrolled = window.pageYOffset || document.body.scrollTop
//     //   // console.log(`offset: ${scrolled}, img: ${elementImg.getBoundingClientRect().top}, calc: ${scrolled - elementImg.getBoundingClientRect().top}`)
//     //   console.log(`1: ${scrolled}, 2: ${elementImg.scrollTop}`)
//     //   requestAnimationFrame(() => {
//     //     let transformValue = 0;
//     //     scrolled = 0 - (scrolled * 0.1);
//     //     transformValue += scrolled;
//     //     elementImg.style.transform = `translate3d(0,${transformValue}px,0)`
//     //   })
//     // }
//   },
//   exit(direction) {
//     // console.log('Exited triggered with direction ' + direction)
//   },
//   exited(direction) {
//     // console.log('Exited triggered with direction ' + direction)
//   },
// })

// var inputPhoneMask = document.querySelectorAll('.js-masked-phone')
// Inputmask({'mask': '+7 (999) 999 99 99', placeholder: '-'}).mask(inputPhoneMask)

document.querySelector('.js-toggle-menu').addEventListener('click', function (e) {
  let elBody = document.querySelector('body')

  if (!elBody.classList.contains('nav-active')) {
    elBody.classList.add('nav-active')
  } else {
    elBody.classList.remove('nav-active')
  }
});

(function () {
  let elements = document.querySelectorAll('.section--dark')

  Array.prototype.forEach.call(elements, function (el, i) {
    var setTheme = function () {
        document.querySelector('body').setAttribute('data-theme', 'dark')
      },
      unsetTheme = function () {
        document.querySelector('body').removeAttribute('data-theme')
      }

    new Waypoint.Inview({
      element: el,
      enter(el) {
        'up' == el && setTheme()
      },
      entered(el) {
        'up' == el && unsetTheme()
      },
      exit(el) {
        'down' == el && setTheme()
      },
      exited(el) {
        'down' == el && unsetTheme()
      },
      offset: '100%',
    })
  })
})()

